import { call, put, all, takeEvery } from "redux-saga/effects";

import { GET_PARTNERS_LIST } from "./actionType";
import { getPartnersListSuccess, getPartnersListFailure } from "./action";
import { getPartnersListAPI } from "../../helpers/fakebackend_helper";

// Get Partners List
function* getPartnersList() {
  try {
    const response = yield call(getPartnersListAPI);
    yield put(getPartnersListSuccess(response));
  } catch (error) {
    yield put(getPartnersListFailure(error));
  }
}

export function* watchGetPartnersList() {
  yield takeEvery(GET_PARTNERS_LIST, getPartnersList);
}

export default function* Partners() {
  yield all([watchGetPartnersList()]);
}
